import { ClassProvider } from '@angular/core';

import { NEVER, Observable } from 'rxjs';

export abstract class WysiwygUploader {
  public abstract upload(data: any): Observable<any>;
}

export class NoopWysiwygUploader implements WysiwygUploader {
  public upload(data: any): Observable<any> {
    console.warn(`[NoopWysiwygUploader] Noop`);
    return NEVER;
  }
}

export interface WysiwygUploaderProvider extends ClassProvider {
  provide: typeof WysiwygUploader;
}
